// extracted by mini-css-extract-plugin
export default {"controlBtn":"BFilter-module_controlBtn_ba05c7d0","freeUpgrade":"BFilter-module_freeUpgrade_a05130f3"};